import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { HotkeysModule } from '@ngneat/hotkeys';

import { VbHotkeysRegistrationDirective } from './VbHotkeysRegistration.Directive';
import { VbHotkeysHelpComponent } from './VbHotkeysHelp.Component';

const components = [
	VbHotkeysHelpComponent,
	VbHotkeysRegistrationDirective
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		BsDropdownModule,
		HotkeysModule
	]
})
export class VbHotkeysModule {}
